import { useState } from "react";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SkipNextIcon from "@mui/icons-material/SkipNext";


export interface Column {
  id: string;
  header: string;
  accessorKey?: string;
  align?: "left" | "center" | "right";
  cell: (info: any) => JSX.Element;
}

interface TableProps {
  columns: Column[];
  data: Record<string, any>[];
  pageIndex: number;
  pageSize: number;
  totalRows: number;
  onPageChange: (newPage: number) => void;
  onPageSizeChange: (newPageSize: number) => void;
}

const Table: React.FC<TableProps> = ({ columns, data, pageIndex, pageSize, totalRows, onPageChange, onPageSizeChange }) => {
  const [sorting, setSorting] = useState<any[]>([]);
  const [filtering, setFiltering] = useState<string>("");

  const totalPages = Math.ceil(totalRows / pageSize);
  // console.log(data, 'dataTable');

  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  return (
    <>
      {
        data && data.length > 0 ? (
          <>
          <div className="table-container">
            <table className="w3-table-all">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id} onClick={header.column.getToggleSortingHandler()} style={{ padding: "0 15px" }}>
                        {header.isPlaceholder ? null : (
                          <div>
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            {header.column.getIsSorted() ? (header.column.getIsSorted() === "asc" ? " 🔼" : " 🔽") : null}
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} >
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            {/* Pagination Controls */}
          </div>
          <div className="pagination " style={{padding:'10px 15px'}}>
              <button disabled={pageIndex === 1} onClick={() => onPageChange(1)}>
                <SkipPreviousIcon />
              </button>
              <button disabled={pageIndex === 1} onClick={() => onPageChange(pageIndex - 1)}>
                <KeyboardArrowLeftIcon />
              </button>
              <span>
                Page <strong>{pageIndex}</strong> of <strong>{totalPages}</strong>
              </span>
              <button disabled={pageIndex === totalPages} onClick={() => onPageChange(pageIndex + 1)}>
                <KeyboardArrowRightIcon />
              </button>
              <button disabled={pageIndex === totalPages} onClick={() => onPageChange(totalPages)}>
                <SkipNextIcon />
              </button>
            </div>
            </>
        ) :
          <div >
            <p style={{padding:'10px',width:'100%', textAlign:'center'}}>No data available</p>
          </div>
      }
    </>
  );
};

export default Table;
